import { FC, SVGAttributes } from 'react';

const Bulb: FC<SVGAttributes<SVGElement>> = (props) => {
    return (
        <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.9994 7C10.8501 6.99925 9.73562 7.39445 8.84356 8.11908C7.95151 8.84372 7.33632 9.85354 7.10154 10.9786C6.86676 12.1036 7.02673 13.2752 7.55452 14.2962C8.08231 15.3171 8.9457 16.125 9.99937 16.584V19H13.9994V16.584C15.0521 16.1243 15.9144 15.3162 16.4414 14.2955C16.9684 13.2748 17.128 12.1039 16.8934 10.9794C16.6587 9.85492 16.0441 8.84551 15.1529 8.12082C14.2616 7.39613 13.1481 7.00035 11.9994 7Z"
                fill="currentColor"
            />
            <path
                d="M21 12H22M18.5 5.5L19.5 4.5M12 3V2M5.5 5.5L4.5 4.5M3 12H2M10 22H14M17 12C16.9997 11.0986 16.7558 10.2141 16.294 9.43993C15.8323 8.66581 15.1698 8.03092 14.3768 7.60245C13.5837 7.17397 12.6896 6.96784 11.789 7.00588C10.8884 7.04391 10.0149 7.3247 9.26079 7.81851C8.50671 8.31233 7.90014 9.00082 7.50527 9.81112C7.11041 10.6214 6.94194 11.5234 7.01769 12.4216C7.09343 13.3198 7.41058 14.1808 7.93557 14.9135C8.46056 15.6463 9.17386 16.2234 10 16.584V19H14V16.584C14.8919 16.1947 15.6508 15.5537 16.1837 14.7394C16.7166 13.9252 17.0003 12.9731 17 12Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default Bulb;
